export default __webpack_public_path__ + "static/media/think-different1152.0f89ce46.jpg";